import styled from 'styled-components'

import * as ds from '@bob/design-system'

export const Main = styled.div`
  @media screen and (${ds.breakpoint.TABLET}) {
    padding-left: 40px;
  }
  @media screen and (${ds.breakpoint.LAPTOP}) {
    padding-left: 90px;
  }
  @media screen and (${ds.breakpoint.LAPTOP_L}) {
    padding-left: 140px;
  }
`

export const GalleryColumn = styled.div`
  margin-top: -10px;

  @media screen and (${ds.breakpoint.TABLET}) {
    margin-top: -20px;
  }

  ${ds.Gallery}, ${ds.GallerySkeleton} {
    position: sticky;
    top: 90px;
  }

  position: relative;
`

export const Container = styled(ds.Container)`
  @media screen and (${ds.breakpoint.TABLET}) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  ${ds.BreadCrumbs}, ${ds.BreadCrumbsSkeleton} {
    flex: 0 0 100%;
    margin-bottom: 15px;

    @media screen and (${ds.breakpoint.TABLET}) {
      margin-bottom: 32px;
    }
  }

  ${GalleryColumn} {
    flex: 1 1 25%;
  }

  ${Main} {
    flex: 2;
  }
`
